var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefreshIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      marginRight: 4,
      marginTop: "-1px"
    },
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 0.875C10.4531 0.875 10.125 1.22656 10.125 1.625V3.38281C9.1875 2.07031 7.66406 1.25 6 1.25C3.77344 1.25 1.82812 2.67969 1.14844 4.78906C1.03125 5.1875 1.24219 5.60938 1.64062 5.72656C2.03906 5.84375 2.46094 5.63281 2.57812 5.23438C3.04688 3.75781 4.42969 2.75 6 2.75C7.17188 2.75 8.25 3.33594 8.90625 4.25H7.875C7.45312 4.25 7.125 4.60156 7.125 5C7.125 5.42188 7.45312 5.75 7.875 5.75H10.875C11.2734 5.75 11.625 5.42188 11.625 5V1.625C11.625 1.22656 11.2734 0.875 10.875 0.875ZM10.3359 7.29688C9.9375 7.17969 9.51562 7.39062 9.39844 7.78906C8.92969 9.26562 7.54688 10.25 6 10.25C4.80469 10.25 3.72656 9.6875 3.07031 8.75H4.125C4.52344 8.75 4.875 8.42188 4.875 8C4.875 7.60156 4.52344 7.25 4.125 7.25H1.125C0.703125 7.25 0.375 7.60156 0.375 8V11.375C0.375 11.7969 0.703125 12.125 1.125 12.125C1.52344 12.125 1.875 11.7969 1.875 11.375V9.64062C2.78906 10.9531 4.3125 11.75 5.97656 11.75C8.17969 11.75 10.125 10.3438 10.8047 8.23438C10.9453 7.83594 10.7344 7.41406 10.3359 7.29688Z",
    fill: "#555555"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.a96f3a2bc482f3ee75c0f891d470840b.svg";
export { ForwardRef as ReactComponent };